import { isEmpty } from 'lodash';

export const DEFAULT_MAIL_DATE_FILTER_ID = 'last14';

export const mailDateFilters = /** @type {const} */ ([
  { id: 'next45', label: 'Within the next 45 days', mailDateLowerBoundDays: 0, mailDateUpperBoundDays: 45 },
  { id: 'last14', label: 'Within the last 14 days', mailDateLowerBoundDays: -14, mailDateUpperBoundDays: 0 },
  { id: 'last30', label: 'Within the last 30 days', mailDateLowerBoundDays: -30, mailDateUpperBoundDays: 0 },
  { id: 'last45', label: 'Within the last 45 days', mailDateLowerBoundDays: -45, mailDateUpperBoundDays: 0 }
]);

export function shouldValidateCampaignRow(originalRow, updatedRow) {
  let rowToValidate = null;

  if (isEmpty(updatedRow?.name) || isEmpty(updatedRow?.number)) {
    return rowToValidate;
  } else {
    if (updatedRow?.name.trim() === originalRow?.name.trim() && updatedRow?.number.trim() === originalRow?.number.trim()) {
      return rowToValidate;
    } else {
      rowToValidate = updatedRow;
      return rowToValidate;
    }
  }
}
